import * as React from 'react';

function SvgCheck(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <circle cx={10} cy={10} r={7.25} stroke={props.color} strokeWidth={1.5} />
      <path
        d="M7 10.5l2 2 4-4"
        stroke={props.color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgCheck;
